import styled from "styled-components";

const MyDiv = styled.div`
  .page_wrapper {
    padding: 16px 20px;
  }

  .btn {
    background: #006838;
    color: white;
    &:hover {
      background: #005529;
    }
  }

  .flex_header {
    align-items: center;
    justify-content: space-between;
  }

  .table_header {
    background-color: #f9fafb !important;
  }

  .metric-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 14px 18px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  }

  .url-text {
    font-family: monospace;
    font-size: 11px;
    color: #475569;
    background: #f1f5f9;
    padding: 2px 6px;
    border-radius: 4px;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
`;

export default MyDiv;
